<script lang="ts" setup>
import InvestorHero from '@/domains/investor/components/Hero/Hero.vue'
import FileList from '@/domains/investor/components/FileList/FileList.vue'
import { useFetchTable } from '@/domains/investor/composables/useFetchTable'
import Table from '@/domains/investor/components/Table/Table.vue'

definePageMeta({
  layout: 'investor',
})

const { fetchTable } = await useFetchTable()
const table = await fetchTable('relacjeInwestorkieObligacje')

const { t, locale } = useI18n()

useHead(() => ({
  title: t('pageTitles.investorBonds.title'),
  meta: [
    {
      name: 'description',
      content: t('pageTitles.investorBonds.meta'),
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: t(`pageTitles.investorBonds.canonical.${locale.value}`),
    },
    {
      rel: 'alternate',
      hreflang: 'pl',
      href: t('pageTitles.investorBonds.canonical.pl'),
    },
    {
      rel: 'alternate',
      hreflang: 'en',
      href: t('pageTitles.investorBonds.canonical.en'),
    },
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: t('pageTitles.investorBonds.canonical.pl'),
    },
  ],
}))
</script>

<template>
  <div class="bondsView">
    <InvestorHero
      :title="$t('investor.bonds.title')"
      image="/images/investor/hero/obligacje.png"
    />

    <UiSection
      class="bondsView__content"
      color="white"
    >
      <Table
        v-if="table.data.value?.table"
        :table="table.data.value"
        :options="{ highlightFirstColumn: true }"
      />
    </UiSection>

    <FileList
      request-id="oswiadczenia-dotyczace-ksztaltowania-sie-wskaznikow-finansowych"
      variant="list"
      :file-item-options="{
        showFormat: true,
        showSize: true,
      }"
      :file-item-link-options="{label:t('investor.files.seeFile')}"
    />

    <FileList
      request-id="informacje-dotyczace-prognozy-ksztaltowania-sie-zobowiazan-finansowych"
      variant="list"
      :file-item-options="{
        showFormat: true,
        showSize: true,
      }"
      :file-item-link-options="{label:t('investor.files.seeFile')}"
    />
  </div>
</template>

<style lang="scss" scoped>
.bondsView {
  :deep(.table th) {
    background-color: $gray-300;
  }

  :deep(.file-list) {
    padding-top: 0;
  }
}
</style>
